/**
 * Check for correct domain name (dev/test suffix) and port.
 *
 * For example for gateway:
 *    - on dev environment - gwdev.alaricsecurities.net:54072
 *    - on test environment - gwtest.alaricsecurities.net:54073
 */

const USE_REPORTING_API_DIRECTLY = false;
const GATEWAY_ROOT = 'gwtest.alaricsecurities.net:54073';

const mainConfig = {
  portalId: 1470, // DemoAceCapitalPortal
  portalLang: 'bg',
  auth: {
    issuer: 'https://auth-test.alaricsecurities.net',
    clientId: 'DemoAceCapitalPortal',
    loginRedirectUrl: 'https://pari-test.capital.bg/auth-result',
    redirectUrlConfirmEmail: 'https://pari-test.capital.bg/email-confirm',
    redirectUrlEmailConfirmed: 'https://pari-test.capital.bg/email-confirmed',
    redirectUrlResetEmail: 'https://pari-test.capital.bg/email-reset',
    redirectUrlResendEmail: 'https://pari-test.capital.bg/email-resend',
    redirectUrlPhoneVerified: 'https://pari-test.capital.bg/phone-verify',
    postLogoutRedirectUrl: 'https://pari-test.capital.bg/authentication/login',
    redirectUrlFunds: 'https://pari-test.capital.bg/funds',
    redirectUrlProfileSecurity: 'https://pari-test.capital.bg/overview',
    // 1 - Alaric, 2 - Flb
    tenantId: 2002,
    scopes: [
      'roles',
      'TokenserverAPI.write',
      'TokenserverAPI.read',
      'tenant',
      'Alaric.FileStorage',
      'offline_access',
      'Alaric.Payment',
      'Alaric.Gateway',
      'Alaric.CRM',
      'IdentityServerApi',
      'phone',
      'two_factor_enabled',
      'Alaric.Audit',
      'Alaric.Subscription',
      'Alaric.Entitlement',
      'Alaric.Reporting',
      'platform',
      'Alaric.MarketData',
      'user_relation',
      'Alaric.News',
      'Alaric.Tapi',
      'Alaric.Fundamental',
      'openid',
      'profile',
      'email',
      'Alaric.MS',
      'Alaric.Administrative',
      'openid',
    ],
  },
  crm: {
    url: 'https://crm-api-test.alaricsecurities.net',
  },
  pwp: {
    url: 'https://alaric-pro-test.alaricsecurities.net/',
  },
  fundamental: {
    url: 'https://fundamental-test.alaricsecurities.net/api',
  },
  reporting: {
    url: (
      USE_REPORTING_API_DIRECTLY
        ? 'https://rpt-test.alaricsecurities.net/api/v1'
        : `https://${GATEWAY_ROOT}/reporting`
    ),
  },
  reportingFile: {
    url: 'https://rpt-test.alaricsecurities.net/api',
  },
  news: {
    url: 'https://news-test.alaricsecurities.net/api/v1',
  },
  file: {
    url: 'https://file-test.alaricsecurities.net/api/v1',
  },
  gateway: {
    url: GATEWAY_ROOT,
  },
  marketData: {
    url: 'ws://38.132.123.43:8002',
  },
  trading: {
    url: 'wss://tapi-eu-south-1.successionsys.com/wstapi/test',
  },
  payment: {
    url: 'https://pay-test.alaricsecurities.net/api/v1/Payment',
  },
  ams: {
    url: 'https://ams-test.alaricsecurities.net/api',
  },
  cdn: {
    url: 'https://cdn-test.alaricsecurities.net',
  },
  capital_rss: {
    url: 'https://www.capital.bg/rss/investment-game/?limit=12',
  },
  currentEnv: 'test',
  dateFormat: 'LL',
  links: {
    abonamentUrl: 'https://www.capital.bg/abonament/',
    fundPortalUrl: 'https://myportal-test.alaric.bg/',
    privacyPolicyUrl: 'https://stage3.alaricsecurities.com/privacy-policy/',
    privacyPolicyCapitalUrl: 'https://www.economedia.bg/privacy',
    tournamentRulesCapitalUrl: 'https://www.capital.bg/pari/pravila/',
    cookiesPolicyUrl: 'https://stage3.alaricsecurities.com/cookie-policy/',
    helpCenterUrl: 'https://alaricsecurities.com/contact/#',
    signUpUrl: 'https://alaric-pro-test.alaricsecurities.net/authentication/sign-up/individual?portalId=DemoAceCapitalPortal',
    etfInfo: 'https://alaricsecurities.com/services/etf-trading/',
    alaricUrl: 'https://alaricsecurities.com/platforms/hammer-lite-web-mobile/',
  },
};

/** Needed for tests */
export function changeEnv(env: any) { mainConfig.currentEnv = env; }

export default mainConfig;
